import React, { useEffect, useState } from 'react';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { useNavigate } from "react-router-dom"
import { FatigueAssessmentForm, SubmitActionModel, SubmitAssessmentModelBase } from 'shared/models/api/models';
import { submitFatigueAssessment, submitOnBehalfAssessment } from 'shared/services/fatigueAssessmentApi';
import { IUserSearchResult, SubmitAssessmentModel, SubmitOnBehalfModel } from 'shared/models/api/models';
import { isoDateStringToBrowserSafeString } from 'shared/models/mapping/mapping';
import { InfoOutlined as InfoIcon, Warning as WarningIcon } from '@mui/icons-material';
import InfoModal from "components/ui/InfoModal"
import { FormModal, FormModalSubHeader, FormModalPaddedBody, ModalButtonRow, ModalButton } from 'components/ui/FormModal';
import { fatigueAssessmentRoute } from 'components/portal/fatigueAssessment/FatigueAssessmentRoutes';
import { ToolTipButton, ToolTipQuestionButton } from "components/menu/Labels";
import { Button } from 'reactstrap';
import FatigueAssessmentQuestions from './FatigueAssessmentQuestions'
import FatigueAssessmentAnswers from './FatigueAssessmentAnswers';
import FatigueAssessmentAction from './FatigueAssessmentAction'

import {
    HoursChoices,
    AlertChoices,
    AlcoholicDrinksChoices,
    SexChoices,
    YesNoChoice,
    UserChoice,
    LocationChoice,
    DateChoice,
    TimeChoice,
    MultilineTextInput,
    OnbehalfChoices,
    onbehalfOptions,
    YesNoCheck,
    OtherLocation
} from './FormControls';

import {
    FatigueAssessmentFormState,
    fatigueAssessmentFormState as fs,
    handleChange,
    fieldInvalid,
    enableValidation,
    resetValidation,
    updateFormState,
    handleOptionTextChange,
    handleCheckboxChange,
} from './FatigueAssessmentFormState'

import {
    FatigueAssessmentActionState,
    fatigueAssessmentActionState,
    enableActionValidation,
    actionStateInvalid
} from './FatigueAssessmentActionState'
import { questionsUnanswered } from '../forms/util';


const OnBehalfHeader = () => {
    const [form, setForm] = useState({} as FatigueAssessmentForm)
    const [showText, setShowText] = useState(false);
    const q = FatigueAssessmentQuestions;

    useEffect(() => {
        const sub = fs.subscribe((s: FatigueAssessmentFormState) => {
            setForm(s.form);
            if (s.form.onBehalfReason) {
                const hideText = (onbehalfOptions.map(o => o.label).includes(s.form.onBehalfReason ?? '') && s.form.onBehalfReason !== 'Other');
                setShowText(!hideText);
            }
        });

        return () => { sub.unsubscribe(); };
    }, []);

    return (
        <>
            <div className="main-form-row">Questions are phrased as the user would read them. Please answer on behalf of the user relative to the time of submitting the fatigue assessment.</div>
            <div className="main-form-row">
                <div className="question">{q.onBehalfReason.value}</div>
                <div className="answer">
                    <OnbehalfChoices onAnswerUpdate={handleOptionTextChange(q.onBehalfReason.key)} invalid={fieldInvalid(q.onBehalfReason.key)} />
                </div>

            </div>
            <div className="main-form-row  row-divider">
                {
                    showText &&
                    <>
                        <div className="question"></div>
                        <div className="answer"><MultilineTextInput onAnswerUpdate={handleChange(q.onBehalfReason.key)} invalid={fieldInvalid(q.onBehalfReason.key)} /></div>
                    </>
                }
            </div>

            <div className="main-form-row row-divider">
                <div className="question">{q.onBehalfUser.value}<ToolTipButton text={q.onBehalfUser.tooltip} /></div>
                <div className="answer">
                    <UserChoice
                        onAnswerUpdate={handleChange(q.onBehalfUser.key)}
                        invalid={fieldInvalid(q.onBehalfUser.key)} />
                </div>
            </div>
        </>
    );
}

interface MainFormProps {
    partAInitialForm?: boolean,
    partADeclarationForm?: boolean,
    partBForm?: boolean
}

const MainForm = (props: MainFormProps) => {
    const [form, setForm] = useState({} as FatigueAssessmentForm)
    const defaultUser = { id: null, fullname: "" } as IUserSearchResult;
    const [defaultSupervisor, setDefaultSupervisor] = useState({ ...defaultUser, id: form.supervisor?.id || null, fullname: form.supervisor?.fullname || "" });
    const [defaultSignOnLocation, setDefaultSignOnLocation] = useState(form.signOnLocation?.id ?? undefined);
    const [defaultShiftStartTime, setDefaultShiftStartTime] = useState(form.shiftStartTime);
    const [dataCollectionShown, setDataCollectionShown] = useState(false);
    const [showSupervisor, setShowSupervisor] = useState(false); 
    const q = FatigueAssessmentQuestions;
    const a = FatigueAssessmentAnswers;

    useEffect(() => {
        const sub = fs.subscribe((s: FatigueAssessmentFormState) => {
            setForm(s.form);

            let defaultSupervisor = { ...defaultUser, id: s.form.supervisor?.id || null, fullname: s.form.supervisor?.fullname || "" };
            setDefaultSupervisor(defaultSupervisor);

            let sol = s.form.signOnLocation?.id ?? undefined;
            setDefaultSignOnLocation(sol);

            setDefaultShiftStartTime(s.form.shiftStartTime);
            setShowSupervisor(s.form.signOnLocationId === OtherLocation.value);
        });

        return () => { sub.unsubscribe(); };
    }, []);

    

    return (
        <div key={form.id}>
            {/* <InfoModal
                modalClass={'fa-privacy-modal'}
                html={<div><i>
                    <p>
                        BHP wishes to collect and process health information about you in order to conduct this Fatigue Assessment.
                        The information we will collect about you will include information related to recent sleep, consumption of alcoholic drinks, your sex and other health related information.
                        By completing this form, you consent to BHP collecting and processing your personal information, including information previously collected, for the purposes described above.
                        Your data is accessed by your line leader (supervisor) only for the purposes of managing safety, and is not shared to third parties or outside of the portal.
                    </p>

                    <p>
                        This consent is voluntary and you are free to withdraw, alter or restrict your consent at any time by notifying BHP in writing.
                        However, without access to this information you may not be able to report for work.
                    </p>

                    <p>
                        We will manage all of your information in accordance with applicable privacy laws.
                        For more information about how BHP conduct our privacy management practices, and about your rights in relation to information held by BHP, please see
                    </p>
                    <p><a href='https://spo.bhpbilliton.com/sites/DW/Pages/Privacy.aspx' target="_blank">BHP Global Privacy Notice for BHP workers.</a></p>

                </i></div>}
                isOpen={!dataCollectionShown}
                closeAction={() => { setDataCollectionShown(true); }}
            /> */}
            {props.partAInitialForm === true &&
                <>
                    <div className="main-form-row row-divider">
                        <div className="question">{q.hoursSleep24Hrs.value}</div>
                        <div className="answer">
                            <HoursChoices minTime={a.hoursSleep24Hrs.minTime} maxTime={a.hoursSleep24Hrs.maxTime} onAnswerUpdate={handleChange(q.hoursSleep24Hrs.key)} invalid={fieldInvalid(q.hoursSleep24Hrs.key)} />
                        </div>
                    </div>

                    <div className="main-form-row row-divider">
                        <div className="question">{q.hoursSleep48Hrs.value}</div>
                        <div className="answer">
                            <HoursChoices minTime={a.hoursSleep48Hrs.minTime} maxTime={a.hoursSleep48Hrs.maxTime} onAnswerUpdate={handleChange(q.hoursSleep48Hrs.key)} invalid={fieldInvalid(q.hoursSleep48Hrs.key)} />
                        </div>
                    </div>

                    <div className="main-form-row row-divider">
                        <div className="question">{q.currentHoursAwake.value}</div>
                        <div className="answer">
                            <HoursChoices minTime={a.hoursAwake.minTime} maxTime={a.hoursAwake.maxTime} onAnswerUpdate={handleChange(q.currentHoursAwake.key)} invalid={fieldInvalid(q.currentHoursAwake.key)} />
                        </div>
                    </div>
                </>
            }

            {props.partBForm === true &&
                <>
                    <div className="main-form-row row-divider">
                        <div className="question">{q.feelAlert.value}</div>
                        <div className="answer">
                            <AlertChoices onAnswerUpdate={handleChange(q.feelAlert.key)} invalid={fieldInvalid(q.feelAlert.key)} />
                        </div>
                    </div>

                    <div className="main-form-row row-divider">
                        <div className="question">{q.alcoholicDrinks.value}</div>
                        <div className="answer">
                            <AlcoholicDrinksChoices onAnswerUpdate={handleChange(q.alcoholicDrinks.key)} invalid={fieldInvalid(q.alcoholicDrinks.key)} />
                        </div>
                    </div>

                    <div className="main-form-row row-divider">
                        <div className="question">{q.gender.value}</div>
                        <div className="answer">
                            <SexChoices onAnswerUpdate={handleChange(q.gender.key)} invalid={fieldInvalid(q.gender.key)} />
                        </div>
                    </div>

                    <div className="main-form-row row-divider">
                        <div className="question">{q.unfitSubstanceCheck.value}</div>
                        <div className="answer">
                            <YesNoChoice name={q.unfitSubstanceCheck.key} onAnswerUpdate={handleChange(q.unfitSubstanceCheck.key)} invalid={fieldInvalid(q.unfitSubstanceCheck.key)} />
                        </div>
                    </div>

                    <div className="main-form-row row-divider">
                        <div className="question">{q.concentrationCheck.value}</div>
                        <div className="answer">
                            <YesNoChoice name={q.concentrationCheck.key} onAnswerUpdate={handleChange(q.concentrationCheck.key)} invalid={fieldInvalid(q.concentrationCheck.key)} />
                        </div>
                    </div>
                </>
            }

            {(props.partADeclarationForm === true || props.partBForm === true) &&
                <>
                    <div className="main-form-row row-divider">
                        <div className="question">{q.signOnLocationId.value}<ToolTipButton text={q.signOnLocationId.tooltip} /></div>
                        <div className="answer">
                            <LocationChoice defaultLocationId={defaultSignOnLocation}
                                onAnswerUpdate={handleChange(q.signOnLocationId.key)} invalid={fieldInvalid(q.signOnLocationId.key)} />
                        </div>
                    </div>

                    {
                        showSupervisor &&
                        <div className="main-form-row row-divider">
                            <div className="question">{q.shiftSupervisorId.value}<ToolTipButton text={q.shiftSupervisor.tooltip} /></div>
                            <div className="answer">
                                <UserChoice
                                    supervisorFilter={true}
                                    defaultUser={defaultSupervisor}
                                    onAnswerUpdate={(user: IUserSearchResult) => handleChange(q.shiftSupervisorId.key)(user.id)}
                                    invalid={fieldInvalid(q.shiftSupervisorId.key)} />
                            </div>
                        </div>
                    }

                    <div className="main-form-row row-divider">
                        <div className="question">{q.partialShiftStartDate.value}</div>
                        <div className="answer">
                            <DateChoice date={defaultShiftStartTime} onAnswerUpdate={handleChange(q.partialShiftStartDate.key)} invalid={fieldInvalid(q.partialShiftStartDate.key)} />
                        </div>
                    </div>

                    <div className="main-form-row row-divider">
                        <div className="question">{q.partialShiftStartTime.value}</div>
                        <div className="answer">
                            <TimeChoice time={defaultShiftStartTime} onAnswerUpdate={handleChange(q.partialShiftStartTime.key)} invalid={fieldInvalid(q.partialShiftStartTime.key)} />
                        </div>
                    </div>

                    <div className="main-form-row row-divider">
                        <div className="question" dangerouslySetInnerHTML={{ __html: q.privacyPolicy.value }}></div>
                        <div className="answer">
                            <YesNoCheck name={q.privacyPolicy.key} onAnswerUpdate={handleCheckboxChange(q.privacyPolicy.key)} invalid={fieldInvalid(q.privacyPolicy.key)} />
                        </div>
                    </div>
                </>
            }           

        </div>
    );

}


const OnBehalfFooter = () => {


    return (
        <>

            <div className="main-form-row main-form-subheader">Supervisors - Action taken</div>
            <FatigueAssessmentAction />
        </>
    );
}


const LoadingMessage = () => {
    return (
        <>
            <div>Loading...</div>
        </>
    );
}


type ResultModalProps = {
    resultScore?: number,
    isOpen: boolean,
    onBehalf: boolean,
    closeAction: () => void
}

const ResultModal = (props: ResultModalProps) => {
    const lowScoreThreshold = 1;
    const formTitle = () => {
        if (props.onBehalf == true) {
            return "On-behalf form";
        }
        return "form";
    }

    return (
        <FormModal {...props} headingText={`Fatigue Assessment ${formTitle()}`}>

            <FormModalSubHeader>
                <div>{`Thank you for submitting the ${formTitle().toLowerCase()}.`}</div>
            </FormModalSubHeader>

            <FormModalPaddedBody>
                <div className="modal-body-content-container">

                    <div className="modal-body-content">
                        {(props.resultScore !== undefined && props.resultScore <= lowScoreThreshold) ?
                            <div className="p-2 pb-5"><InfoIcon className="icon-score-low mr-4" />Risk score was low.</div>
                            :
                            <div className="p-2 pb-5">
                                <WarningIcon className="icon-score-high mr-4 mb-3" />
                                <div className="d-inline-block">
                                    Please report to the Shift Supervisor immediately.<br />
                                    Do not commence any work activities until you are authorised to do so.
                                </div>
                            </div>
                        }
                    </div>

                    <ModalButtonRow>
                        <ModalButton onClick={props.closeAction} text="OK" primaryButton={true} />
                    </ModalButtonRow>

                </div>
            </FormModalPaddedBody>
        </FormModal>
    );
}


interface FormContentsProps {
    onBehalf?: boolean,
    assessment?: FatigueAssessmentForm,
    loading?: boolean
}

const FormContents = (props: FormContentsProps) => {
    const [onBehalf] = useState(props.onBehalf === true);
    const [isLoading, setIsLoading] = useState(props.loading === true);
    const [clearForm, setClearForm] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [displayAllRequired, setAllRequired] = useState(false);
    const [displayErrorSubmitting, setErrorSubmitting] = useState(false);
    const [resultScore, setResultScore] = useState(-1);
    const [displayResultModal, setResultModal] = useState(false);
    const [form, setForm] = useState({} as FatigueAssessmentForm);
    const [action, setAction] = useState({} as SubmitActionModel);
    const [partAInitialForm, setPartAInitialForm] = useState(true);
    const [partADeclarationForm, setPartADeclarationForm] = useState(false);
    const [partBForm, setPartBForm] = useState(false);
    const [priorSleepWakeScore, setPriorSleepWakeScore] = useState(0);
    const q = FatigueAssessmentQuestions;

    const navigate = useNavigate();

    const onNext = () => {

        enableValidation();

        let hoursSleep24Hrs = Number(form.hoursSleep24Hrs || -1);
        let hoursSleep48Hrs = Number(form.hoursSleep48Hrs || -1);
        let currentHoursAwake = typeof (form.currentHoursAwake) === "number" ? form.currentHoursAwake : -1;

        if (hoursSleep24Hrs === -1 || hoursSleep48Hrs === -1 || currentHoursAwake === -1) {
            setAllRequired(true);
        }
        else {

            resetValidation();

            let pointsSleep24hours = 0;
            let pointsSleep48hours = 0;

            //Evaluate sleep 24 hours points
            if (hoursSleep24Hrs <= 2) {
                pointsSleep24hours = 12;
            } else if (hoursSleep24Hrs === 3) {
                pointsSleep24hours = 8;
            } else if (hoursSleep24Hrs === 4) {
                pointsSleep24hours = 4;
            } else {
                pointsSleep24hours = 0;
            }

            //Evaluate sleep 48 hours points
            if (hoursSleep48Hrs <= 8) {
                pointsSleep48hours = 8;
            } else if (hoursSleep48Hrs === 9) {
                pointsSleep48hours = 6;
            } else if (hoursSleep48Hrs === 10) {
                pointsSleep48hours = 4;
            } else if (hoursSleep48Hrs === 11) {
                pointsSleep48hours = 2;
            } else {
                pointsSleep48hours = 0;
            }

            // Calculate wake time points
            let pointsWakeTime = hoursSleep48Hrs > currentHoursAwake ? 0 : currentHoursAwake - hoursSleep48Hrs;
            // Calculate total prior sleep wake score
            let totalWakeScore = pointsSleep24hours + pointsSleep48hours + pointsWakeTime;
            setPriorSleepWakeScore(totalWakeScore);
            console.debug(`Total prior sleep wake score: ${totalWakeScore}`);

            if (totalWakeScore < 9) {
                setPartAInitialForm(false);
                setPartADeclarationForm(false);
                setPartBForm(true);
            } else {
                setPartAInitialForm(false);
                setPartADeclarationForm(true);
                setPartBForm(false);
            }

        }
    }

    const onSubmit = async () => {
        setIsSubmitting(true);
        enableValidation();

        if (props.onBehalf) {
            enableActionValidation();
        }

        let submitAssessment = getAssessmentFromCurrentForm();
        let unansweredCount = 0;


        try {
            unansweredCount = await submitIfAble(submitAssessment);
        }
        finally {

            if (unansweredCount > 0) {
                setAllRequired(true);
                setIsSubmitting(false);
            }
        }
    }

    const getAssessmentFromCurrentForm = () => {
        let submitAssessmentBase = {} as SubmitAssessmentModelBase;
        submitAssessmentBase.id = form.id;
        submitAssessmentBase.hoursSleep24Hrs = Number(form.hoursSleep24Hrs || -1);
        submitAssessmentBase.hoursSleep48Hrs = Number(form.hoursSleep48Hrs || -1);
        submitAssessmentBase.currentHoursAwake = typeof (form.currentHoursAwake) === "number" ? form.currentHoursAwake : -1;
        submitAssessmentBase.signOnLocationId = form.signOnLocationId || -1;
        submitAssessmentBase.supervisorId = submitAssessmentBase.signOnLocationId > 0 ? -2 : (form.supervisorId || -1); // -2 doesn't trigger validation as supervisor only needed if other location is chosen
        let shiftStartLocalTimeString = isoDateStringToBrowserSafeString(`${form.partialShiftStartDate}T${form.partialShiftStartTime}:00`);
        let shiftStartLocalTime = new Date(shiftStartLocalTimeString);
        submitAssessmentBase.shiftStartTime = shiftStartLocalTime;
        submitAssessmentBase.priorSleepWakeScore = priorSleepWakeScore;
        submitAssessmentBase.privacyPolicy = form.privacyPolicy || false;
        return submitAssessmentBase;
    }

    const submitIfAble = async (submitAssessmentBase: SubmitAssessmentModelBase) => {
        let unansweredCount = 0;

        if (partBForm) {
            let submitAssessment = { ...submitAssessmentBase } as SubmitAssessmentModel;
            submitAssessment.feelAlert = Number(form.feelAlert || -1);
            submitAssessment.alcoholicDrinks = typeof (form.alcoholicDrinks) === 'number' ? form.alcoholicDrinks : -1;
            submitAssessment.gender = typeof (form.gender) === 'number' ? form.gender : -1;
            submitAssessment.unfitSubstanceCheck = Number(form.unfitSubstanceCheck || -1);
            submitAssessment.concentrationCheck = Number(form.concentrationCheck || -1);

            if (props.onBehalf) {
                unansweredCount = submitOnBehalf(submitAssessment);
            } else {
                unansweredCount = submitNormal(submitAssessment);
            }
        } else if (props.onBehalf) {
            unansweredCount = submitOnBehalf(submitAssessmentBase);
        } else {
            unansweredCount = submitNormal(submitAssessmentBase);
        }

        return unansweredCount;
    }

    const submitNormal = (submitAssessmentBase: SubmitAssessmentModelBase) => {
        let unansweredCount = questionsUnanswered(submitAssessmentBase);
        if (unansweredCount === 0) {
            submitFatigueAssessment(submitAssessmentBase)
                .then(submitResults)
                .catch(errorResults);
        }
        return unansweredCount;
    }

    const submitOnBehalf = (submitAssessmentBase: SubmitAssessmentModelBase) => {
        let submitOnBehalf = { ...submitAssessmentBase } as SubmitOnBehalfModel;
        submitOnBehalf.userId = Number(form.user?.id || -1);
        submitOnBehalf.onBehalfReason = form.onBehalfReason || "";
        submitOnBehalf.action = action;

        let unansweredCount = questionsUnanswered(submitOnBehalf);
        unansweredCount += actionStateInvalid();

        if (unansweredCount === 0) {
            submitOnBehalfAssessment(submitOnBehalf)
                .then(submitResults)
                .catch(errorResults);
        }
        return unansweredCount;
    }    

    const submitResults = (score: number) => {
        setIsSubmitting(false);

        if (score < 1) {
            errorResults(undefined);
            return;
        }

        showResults(score);
    }

    const showResults = (score: number) => {
        setResultScore(score);
        setResultModal(true);
    }

    const closeResults = () => {
        setResultModal(false);
        navigate(`${fatigueAssessmentRoute.path}`);
    }

    const errorResults = (e: any) => {
        if (e !== undefined) {
            console.error(e);
        }
        setIsSubmitting(false);
        setErrorSubmitting(true);

    }

    useEffect(() => {
        const faSub = fs.subscribe((s: FatigueAssessmentFormState) => {
            setForm(s.form);
            setAllRequired(false);
        });
        const actionSub = fatigueAssessmentActionState.subscribe((s: FatigueAssessmentActionState) => {
            setAction(s.action);
        });
        let faAssessment = props.assessment ?? {} as FatigueAssessmentForm;
        updateFormState(faAssessment);
        resetValidation();
        setIsLoading(props.loading === true);
        setClearForm(false);

        return () => {
            faSub.unsubscribe();
            actionSub.unsubscribe();
        };
    }, [props.loading, props.assessment]);

    return (
        <div className="fa-list-container">
            <div className="main-form-header">Enter all details and click submit</div>

            <InfoModal text="There was an issue submitting the assessment. Please try again." isOpen={displayErrorSubmitting} closeAction={() => { setErrorSubmitting(false); }} />

            <ResultModal resultScore={resultScore} onBehalf={onBehalf} isOpen={displayResultModal} closeAction={closeResults} />

            {isLoading || clearForm ?
                <>
                    <LoadingMessage />
                </>
                :
                <>
                    {onBehalf && partAInitialForm &&
                        <OnBehalfHeader />
                    }

                    <MainForm partAInitialForm={partAInitialForm} partADeclarationForm={partADeclarationForm} partBForm={partBForm}/>

                    {onBehalf && (partADeclarationForm || partBForm) &&
                        <OnBehalfFooter />
                    }

                    <div className="main-form-row form-end">
                        <div className={`invalid-feedback mandatory-details${displayAllRequired === true ? " show" : ""}`}>Please enter all mandatory details in the form.</div>
                        <div className="submit">
                            {partAInitialForm ?
                                <Button className="btn-primary" onClick={onNext}>Next</Button>
                                :
                                <>
                                {isSubmitting ?
                                    <>
                                        <div className="modal fade show" role="dialog" tabIndex={-1}></div>
                                        <Button className="btn-primary disabled">Submitting...</Button>
                                    </>
                                    :
                                    <>
                                        <Button className="btn-primary" onClick={onSubmit}>Submit</Button>
                                    </>
                                }
                                </>
                            }
                        </div>
                    </div>
                </>
            }

        </div>
    );
}

export default FormContents;
